import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface MobilePreviewWidgetUniDriver extends BaseUniDriver {}
